import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import SubFormWidget from "common/form/widgets/SubFormWidget";

export enum ViewType {
	BOXES = "box",
	DROPDOWNS = "dropdowns"
	// , DIALOG = "dialog"
}

const viewTypeInput = ButtonSelect.registerWithOptions([
	{value: ViewType.BOXES, label: "Boxes"},
	{value: ViewType.DROPDOWNS, label: "Dropdowns"}
	// , {value: ViewType.DIALOG, label: "Pop-up"}
]);

@Form({title: "Tags Config"})
export class TagSetsComponentConfig {

	@Input({type: viewTypeInput, title: "View Type"})
	public viewType: ViewType = ViewType.BOXES;

	@Input({type: InputType.CHECKBOX, title: "Multi Select Tags"})
	public multiSelectTags?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Multi Select Tags Within Tagsets"})
	public multiSelectTagsets?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Selected Tags Box"})
	public showSelected?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Collapsible"})
	public collapsible?: boolean;

}

export const tagSetsConfigInput = SubFormWidget.registerForm(TagSetsComponentConfig);



// WEBPACK FOOTER //
// ./src/panels/refineTag/components/TagSetsComponentConfig.ts